import React from 'react'

import Tel from '../../assets/images/telephone-symbol-button.png'
import Fb from '../../assets/images/fb.png'
import Twitt from '../../assets/images/twitter.png'
import Insta from '../../assets/images/instagram.png'


export default function socialTop() {
    return (
        <>
    <div className='sub_page'>
  <div className="hero_area">

    <header className="header_section">

            <div className="top_contact-container">
                <div className="tel_container">

                                <a href="#!">
                                    <img src={Tel} alt=""/> Call : +01 1234567890
                                </a>
                </div>
                <div className="social-container">
                    <a href="#!">
                        <img src={Fb} alt="" className="s-1" />
                    </a>
                    <a href="#!">
                        <img src={Twitt} alt="" className="s-2" />
                    </a>
                    <a href="#!">
                        <img src={Insta} alt="" className="s-3" />
                    </a>
                </div>
                        </div>
                    </header>
                </div>
            </div>
        </>
    )
}
